export default "__VITE_ASSET__d67a715a__"